import { useContext } from 'react';
import { AppContext } from '@CONTEXTS';
import { useApp, useAuth } from '@HOOKS';
import { AppLoading, AppError } from '@MASTER';
import { PrivateLayout, PublicLayout } from '@LAYOUTS';
import { AuthContext } from '@CONTEXTS';

import 'antd/dist/antd.less';
import './App.scss';

const App = () => {
  const { token } = useContext(AuthContext);
  const { appError } = useContext(AppContext);
  const { authLoading, authenticated } = useAuth(token);

  const isAppLoading = useApp();

  if (appError) return <AppError />;

  if (authLoading || isAppLoading || authenticated === null)
    return <AppLoading />;

  if (authenticated) return <PrivateLayout />;

  return <PublicLayout />;
};

export default App;
